module.exports = __webpack_public_path__ + "img/web-img1.48ced10a.png";